<script>
export default {
  name: "input_buttons",
  methods: {
    submit() {
      this.$emit("submit");
    },
    back() {
      this.$emit("back");
    },
  }
}
</script>

<template>
  <div class="d-flex justify-content-center gap-2">
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="back"
    >
      <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
    </button>
    <button
      class="btn btn-primary waves-effect waves-light"
      @click="submit"
    >
      <i class="fas fa-pencil-alt"></i> {{ this.$lang.button.tempolary }}
    </button>
  </div>
</template>
